export const MAX_PIXEL_SIZE = 55;
export const MIN_PIXEL_SIZE = 15;
export const MB_GL_LIGHT = "mapbox://styles/mapbox/light-v10";
export const MB_GL_SATELLITE = "mapbox://styles/mapbox/satellite-v9";
export const MINI_MAP_HEIGHT = 100;
export const MINI_MAP_WIDTH = 100;
